import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignAccountEntitlementsSlice = getBulkActionSlice(
    'assignAccountEntitlementsResult',
);

export const selectAssignAccountEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignAccountEntitlementsResult.shown;

export const selectAssignAccountEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignAccountEntitlementsResult.uuid;

export const selectAssignAccountEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignAccountEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignAccountEntitlementsSlice.actions;
